/* eslint-disable no-console */
import { useEffect } from 'react';

const useVersionCheck = () => {
  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' }); // Prevents caching
        const data = await response.json();
        const { version } = data;
        const currentVersion = import.meta.env.PACKAGE_VERSION;
        if (version !== currentVersion) {
          console.warn(
            `New version detected: ${version} (Current: ${currentVersion})`
          );
          window.stop();
          const cacheKeys = await caches.keys();
          await Promise.all(cacheKeys.map(key => caches.delete(key)));
          window.location.reload();
        }
      } catch {
        console.log('Error fetching version');
      }
    };

    fetchVersion(); // Run immediately
  }, []);
};

export { useVersionCheck };
